module.exports = __webpack_public_path__ + "static/media/mixer-white.ca95d091.png";